import { FormattedMessage as FM } from "react-intl";

import { Alert } from "componentsv2/widgets/Alert";
import EngageLinkCard from "../Components/EngageLinkCard";
import ListEditor from "../Components/ListEditor";
import MelhousPage from "../Components/MelhousPage";
import SaveBar from "../Components/SaveBar";
import useEngageForm from "../helpers/useEngageForm";
import { ENGAGE_LISTS, STYLE_SHEET_CARD, VIEW_ENGAGE } from "../constants";

function MelhousEngage() {
  const engage = useEngageForm();
  const { melhousId, form, failed, saving, saveError, dirty } = engage;

  return (
    <MelhousPage view={VIEW_ENGAGE}>
      <div className="min-w-0 space-y-4 p-3">
        {failed && (
          <p role="alert" className="text-sm text-red-700">
            <FM id="melhous.dash.hotel.error" />
          </p>
        )}
        {form && <EngageLinkCard form={form} onChange={engage.handleChange} />}
        {melhousId &&
          ENGAGE_LISTS.map((config) => (
            <section key={config.id} className={STYLE_SHEET_CARD}>
              <ListEditor config={config} parentId={melhousId} />
            </section>
          ))}
        {saveError && (
          <p role="alert" className="text-sm text-red-700">
            <FM id="melhous.dash.hotel.save_error" />
          </p>
        )}
        <Alert
          text="melhous.dash.saved"
          show={engage.showAlert}
          onClose={engage.closeAlert}
          color="bg-green-200 text-green-800"
          icon="check"
          autoRemove={true}
        />
        {dirty && <SaveBar saving={saving} onSave={engage.handleSave} />}
      </div>
    </MelhousPage>
  );
}

export default MelhousEngage;
